import React, { useState, useRef } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { ConfirmPopup } from 'primereact/confirmpopup';
import { useSelector } from 'react-redux';
import { selectUserData } from '@reduxSlices/user/userSlices';
import config from '@/config';
import storages from './forms/storages';
import carriers from './forms/carriers';
import grade from './forms/grade';
import products from './forms/products';
import gang from './forms/gang';
import suppliers from './forms/suppliers';
import './styles.scss';
import { Formik } from 'formik';
import { Toast } from 'primereact/toast';

const { API_URL } = config;

const forms = {
  carriers,
  grade,
  products,
  gang,
  storages,
  suppliers,
};

const ModalCatalogs = ({ type, visible, hide, catalogsData, updateLoad, allCompany }) => {
  const isEditing = catalogsData && catalogsData?._id;
  const [loading, setLoading] = useState(false);
  const toast = useRef(null);
  const { role } = useSelector(selectUserData) ?? {};

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    setSubmitting(true);
    setLoading(true);

    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_URL}/catalogs`, {
        method: isEditing ? 'PUT' : 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ values, _id: catalogsData?._id, type }),
      });

      if (!response.ok || response.status !== 200) {
        throw new Error('Server error!');
      }

      const data = await response.json();

      if (data?.code === 202) {
        throw new Error(`Користувач уже існує`);
      }

      resetForm();
      hide();
      setLoading(false);
      updateLoad();
    } catch (error) {
      setLoading(false);
      toast.current.show({ severity: 'error', summary: 'Error', detail: `${error}`, life: 5000 });
    }

    setSubmitting(false);
  };

  return (
    <div className='card flex justify-content-center'>
      <Dialog
        header={isEditing ? 'Редагувати дані' : 'Створити'}
        visible={visible}
        className='dialog-form'
        onHide={hide}
      >
        <Formik
          initialValues={forms[type]?.initialValues(catalogsData, role, isEditing)}
          validationSchema={forms[type]?.schema({ role, isEditing })}
          onSubmit={handleSubmit}
        >
          {forms[type]?.form({ role, allCompany, isEditing, loading })}
        </Formik>
      </Dialog>
      <Toast ref={toast} />
    </div>
  );
};

export default ModalCatalogs;

export const DeleteCatalogs = ({ visible, open, hide, catalogsData, updateLoad }) => {
  const toast = useRef(null);
  const buttonEl = useRef(null);

  const handleDelete = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_URL}/catalogs`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ _id: catalogsData?._id }),
      });

      if (!response.ok || response.status !== 200) {
        throw new Error('Server error!');
      }

      toast.current.show({ severity: 'info', summary: 'Видалено', detail: 'Користувач успішно видалена.', life: 3000 });
      updateLoad();
    } catch (error) {
      toast.current.show({ severity: 'error', summary: 'Error', detail: `${error}`, life: 5000 });
    }
  };

  const accept = () => {
    handleDelete();
  };

  const reject = () => {
    toast.current.show({
      severity: 'warn',
      summary: 'Відміна',
      detail: 'Ви відмінили видалення користувача.',
      life: 3000,
    });
  };
  return (
    <div>
      <Toast ref={toast} />
      <ConfirmPopup
        target={buttonEl.current}
        visible={visible}
        onHide={hide}
        message='Ви дійсно хочете видалити користувача?'
        icon='pi pi-exclamation-triangle'
        accept={accept}
        reject={reject}
        acceptLabel='Так'
        rejectLabel='Ні'
      />

      <Button type='button' ref={buttonEl} icon='pi pi-trash' severity='warning' rounded onClick={open} />
    </div>
  );
};
